import Icon from '@admin/components/icon'
import PropTypes from 'prop-types'
import React from 'react'

class Player extends React.Component {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    label: PropTypes.string,
    voicemail: PropTypes.object
  }

  static defaultProps = {
    label: 'listen'
  }

  audio = null

  state = {
    playing: false
  }

  _handleEnd = this._handleEnd.bind(this)
  _handleToggle = this._handleToggle.bind(this)

  render() {
    const { label } = this.props
    return (
      <div className="maha-handset-button-container">
        <div className={ this._getClass()} onClick={ this._handleToggle }>
          <Icon icon={  this._getIcon() } />
        </div>
        { label &&
          <div className="maha-handset-button-label">
            { label }
          </div>
        }
      </div>

    )
  }

  componentDidMount() {
    const { voicemail } = this.props
    this.audio = new Audio(voicemail.asset.signed_url)
    this.audio.addEventListener('ended', this._handleEnd)
  }

  _getClass() {
    const { playing } = this.state
    const classes = ['maha-handset-button']
    if(playing) classes.push('depressed')
    return classes.join(' ')
  }

  _getIcon() {
    const { playing } = this.state
    return playing ? 'pause' : 'play'
  }

  _handleEnd() {
    this.audio.currentTime = 0
    this.setState({
      playing: false
    })
    this._handleHeard()
  }

  _handleHeard() {
    const { voicemail } = this.props
    this.context.network.request({
      endpoint: `/api/admin/phone/voicemails/${voicemail.id}/heard`,
      method: 'PATCH'
    })
  }

  _handleToggle() {
    const { playing } = this.state
    if(!playing) this.audio.play()
    if(playing) this.audio.pause()
    this.setState({
      playing: !playing
    })
  }

}

export default Player
